import PropTypes from 'prop-types';
import { TYPOGRAPHY, COLORS } from '../../../styles/UISystem';
import { CROWN_BLACK } from '../../../styles/brandAssets';

/**
 * SheetHeader Component
 *
 * Black crown + bold heading + optional muted subtitle. The shared header for the
 * PWA conversion/login bottom sheets (PendingProfileOverlay: phone confirm, iOS
 * install, Android install). Heading uses HEADER_LARGE in pure black.
 *
 * @param {node} heading - Bold heading text (e.g. "Join the beta", "Get the web app")
 * @param {node} subtitle - Optional one-liner; accepts a node so callers can bold inline words
 */
export const SheetHeader = ({ heading, subtitle = null }) => (
  <>
    <img src={CROWN_BLACK} alt="" style={{ width: '56px', height: '35px', marginBottom: '12px' }} />

    <div
      style={{
        ...TYPOGRAPHY.HEADER_LARGE,
        color: '#000000',
        textAlign: 'center',
        // Tighten to the subtitle when present; otherwise give the button room.
        marginBottom: subtitle ? '8px' : '32px',
      }}
    >
      {heading}
    </div>

    {subtitle && (
      <div
        style={{
          fontSize: '18px',
          color: COLORS.MEDIUM_GRAY,
          textAlign: 'center',
          marginBottom: '28px',
          maxWidth: '280px',
        }}
      >
        {subtitle}
      </div>
    )}
  </>
);

SheetHeader.propTypes = {
  /** Bold heading text */
  heading: PropTypes.node.isRequired,
  /** Optional muted subtitle (node so inline words can be bolded) */
  subtitle: PropTypes.node,
};

export default SheetHeader;
